const IconDownArrow = (props) => {
    return (
        <svg  className={props.className} xmlns="http://www.w3.org/2000/svg" width="12.5" height="7.147" viewBox="0 0 12.5 7.147" fill="#486f88" >
            <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M12.44,16.239l4.726-4.73a.89.89,0,0,1,1.262,0,.9.9,0,0,1,0,1.265l-5.355,5.359a.892.892,0,0,1-1.232.026L6.448,12.778A.893.893,0,0,1,7.71,11.513Z" transform="translate(-6.188 -11.246)" />
        </svg>


    )
}

export default IconDownArrow;